import React from "react";
import { alertError, alertSuccess } from "../config/toast";
import { getSettings, updateSetting } from "../config/httpRoutes";
import { Row, Form, Col, Card, Button, Image, Container, Table } from "react-bootstrap";
import Loader from "../components/loader";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

class Settings extends React.Component {
  constructor(props) {
    super(props);

    this.imgInputRef = React.createRef();

    this.state = {
      settings: [], // Holds all settings
      loading: false,
      fetchLoading: true,
    };
  }

  componentDidMount() {
    this.fetchSettings();
  }

  fetchSettings = () => {
    getSettings()
      .then((res) => {
        this.setState({ settings: res.data.data, fetchLoading: false });
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || "Could not fetch settings");
        this.setState({ fetchLoading: false });
      });
  };

  handleChange = (e, index) => {
    const { name, value } = e.target;
    this.setState((prevState) => {
      const settings = [...prevState.settings];
      settings[index][name] = value;
      return { settings };
    });
  };

  handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      this.setState((prevState) => {
        const settings = [...prevState.settings];
        settings[index].value = file;
        return { settings };
      });
    }
  };

  handleSubmit = (index) => {
    const { settings } = this.state;
    const setting = settings[index];
    console.log("setting", setting);
    const formData = new FormData();
    formData.append("key", setting.key);
    formData.append("type", setting.type);
    if (setting.type === "image") {
      formData.append("img", setting.value);
      formData.append("value", 'img');
    } else {
      formData.append("value", setting.value);
    }
    console.log("formData", formData);
    this.setState({ loading: true });
    updateSetting(formData)
      .then((res) => {
        alertSuccess("Setting updated");
        this.setState({ loading: false, fetchLoading: false }); // Set fetchLoading to false after successful response
        this.fetchSettings();
      })
      .catch((err) => {
        alertError(err.response?.data?.msg || "Could not update setting");
        this.setState({ loading: false, fetchLoading: false }); // Set fetchLoading to false after error response
      });
  };

  render() {
    const { settings, fetchLoading, loading } = this.state;

    return (
      <Row style={{ marginLeft: 0, marginRight: 0 }}>
        {fetchLoading && <Loader />}
        <Col md={{ span: 8, offset: 3 }} xs={12}>
          <Card style={{ marginTop: "20px", padding: "20px" }}>
            <Container>
              <h2>Admin Settings</h2>
              <h3 className="mt-4">Settings List</h3>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Type</th>
                    <th>Value</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {settings.map((setting, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{setting.key}</td>
                      <td>{setting.type}</td>
                      <td>
                        {setting.type === "image" ? (
                          <>
                            <Image
                              src={typeof setting.value === "string" ? setting.value : URL.createObjectURL(setting.value)}
                              alt="Setting"
                              width="50"
                              height="50"
                            />
                            <Form.Control
                              type="file"
                              onChange={(e) => this.handleFileChange(e, index)}
                              ref={this.imgInputRef}
                            />
                          </>
                        ) : (
                          <Form.Control
                            type="text"
                            name="value"
                            value={setting.value}
                            onChange={(e) => this.handleChange(e, index)}
                          />
                        )}
                      </td>
                      <td>
                        <Button
                          variant="success"
                          onClick={() => this.handleSubmit(index)}
                          disabled={loading}
                        >
                          {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Update"}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Container>
          </Card>
        </Col>
      </Row>
    );
  }
}

export default Settings;
